import React from 'react';
import PropTypes from 'prop-types';

// Messages d'erreur renvoyés par l'API après l'envoi d'un document
const SendDocumentErrors = ({ errors }) => {
  if (!errors?.length) {
    return null;
  }
  return (
    <div role="alert" className="send-document-error-container">
      {errors.map((error) => (
        <div className="send-document-error-message" key={error}>
          {error}
        </div>
      ))}
    </div>
  );
};

SendDocumentErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string)
};

export default SendDocumentErrors;
